import React from "react";
import timeFunction from "../../functions/getTime";

export default function VerticleCard(props) {
  return (
    <div className="w-full rounded-[12px] border-[1px] border-lightGray2 bg-white shadow-sm hover:shadow-md transition-shadow">
      <div
        className="!bg-cover !bg-center h-[170px] bg-lightGray rounded-t-[12px]"
        onClick={() => {
          if (props.page === "newsAndActivity/activity")
            window.open(
              `/${props.lang}/${props.page}/${props.data.slug}`,
              "_self"
            );
        }}
        style={{
          background:
            props.data &&
            props.data.image[0] &&
            `url(${process.env.REACT_APP_API_URL}${props.data.image[0].url}), #D9D9D9`,
        }}
      />
      <div className="p-[20px]">
        <div className="flex gap-[15px]">
          {props.data.date && (
            <div>
              <h1 className="text-datenum font-medium leading-none">
                {
                  timeFunction.getActivityTime(
                    props.lang,
                    props.data.date.startDate
                  )[0]
                }
              </h1>
              <h1 className="text-display font-medium mt-[-8px]">
                {
                  timeFunction.getActivityTime(
                    props.lang,
                    props.data.date.startDate
                  )[1]
                }
              </h1>
              <p className="text-small font-medium whitespace-nowrap">
                {
                  timeFunction.getActivityTime(
                    props.lang,
                    props.data.date.startDate
                  )[3]
                }
              </p>
            </div>
          )}
          <div>
            {props.data.title && (
              <p
                className="text-body text-left cursor-pointer font-bold hover:text-[#FF4713] transition-colors"
                onClick={() => {
                  if (props.page === "newsAndActivity/activity")
                    window.open(
                      `/${props.lang}/${props.page}/${props.data.slug}`,
                      "_self"
                    );
                }}
              >
                {props.lang === "th"
                  ? props.data.title.event_TH
                  : props.data.title.event_EN}
              </p>
            )}
            {props.data.content && (
              <p className="font-normal text-small mt-[10px] text-left line-clamp-4">
                {props.lang === "th"
                  ? props.data.content.detail_TH
                  : props.data.content.detail_EN}
              </p>
            )}
          </div>
        </div>
        <p
          className="text-right text-[#FF4713] text-small font-bold mt-[10px] cursor-pointer"
          onClick={() => {
            if (props.page === "newsAndActivity/activity")
              window.open(
                `/${props.lang}/${props.page}/${props.data.slug}`,
                "_self"
              );
          }}
        >
          {props.lang === "th" ? "อ่านเพิ่มเติม" : "Read More"}
        </p>
      </div>
    </div>
  );
}
